import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PRODUCT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SpPromoRequisitionPage } from '@/features/productRequisition/pages/SpPromoRequisitionPage';
import { spPromoRequisitionSearchSchema } from '@/features/productRequisition/types/productRequisition.types';

export const Route = createFileRoute('/_auth/product/sp-promotional-requisition')({
  beforeLoad: () => requirePermission(PRODUCT_PERMISSIONS.SP_PROMO_REQUISITION_VIEW),
  validateSearch: spPromoRequisitionSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="SP Promotional Requisition">
      <Suspense fallback={<PageLoader />}>
        <SpPromoRequisitionPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
